export const credit_statement = {
  /** Browser tab title (set by the Async component via useAsyncPageDocumentTitle). */
  documentTitle: "Credit statement",
  page_title: "Credit statement",
  back_aria: "Back to use credits",
  print: "Print",
} as const;
